import React, { useState } from "react";
import { X, Lightbulb } from "lucide-react";

// Contextual, dismissible beginner tip. Dismissal is remembered per id in localStorage.
export function GuidedTip({ id, children, className = "" }) {
  const key = `tip_dismissed_${id}`;
  const [open, setOpen] = useState(() => localStorage.getItem(key) !== "1");
  if (!open) return null;
  const dismiss = () => {
    localStorage.setItem(key, "1");
    setOpen(false);
  };
  return (
    <div
      data-testid={`guided-tip-${id}`}
      className={`flex items-start gap-2.5 rounded-xl border border-brand-champagne/40 bg-brand-champagne/10 p-3 text-sm leading-relaxed text-brand-anthracite ${className}`}
    >
      <Lightbulb className="mt-0.5 h-4 w-4 shrink-0 text-brand-champagne" />
      <div className="flex-1">{children}</div>
      <button
        onClick={dismiss}
        data-testid={`guided-tip-dismiss-${id}`}
        aria-label="Dismiss tip"
        className="shrink-0 text-brand-taupe transition-colors hover:text-brand-anthracite"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
